export const SET_USER = 'SET_USER';
export const LOGOUT = 'LOGOUT'
export const SET_GENDER = 'SET_GENDER'
export const SET_MIN_AGE = 'SET_MIN_AGE'
export const SET_MAX_AGE = 'SET_MAX_AGE'
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_CITY = "SET_CITY"
export const SET_PROFILES = "SET_PROFILES"
export const FILTER_PROFILES = "FILTER_PROFILES"
export const SET_ERROR = "SET_ERROR"
export const CLEAR_ERROR = "CLEAR_ERROR"
export const SET_LOADING = "SET_LOADING"
export const CLEAR_ALL_FILTERS = "CLEAR_ALL_FILTERS"
export const SET_SEARCH_QUERY = "SET_SEARCH_QUERY"
export const SET_SORT_OPTION = "SET_SORT_OPTION"